// Динамическая загрузка SheetJS. Либа ~500 КБ минифицировано — держим её в
// отдельном чанке, который тянется только при реальном импорте/экспорте Excel.
// ВАЖНО: статических `import ... from 'xlsx'` во фронте быть не должно — один
// такой импорт возвращает всю либу обратно в главный чанк.
//
// Отдельный хелпер (а не голый `await import('xlsx')` в каждом месте) нужен
// из-за текста ошибки: при 404 чанка (открытая старая вкладка после деплоя)
// Vite бросает английское «Failed to fetch dynamically imported module», а оно
// в паре мест уходит прямо в тост. Перехватываем и отдаём русский текст.
export async function loadXlsx(): Promise<typeof import('xlsx')> {
  try {
    return await import('xlsx')
  } catch (err) {
    // Оригинальную ошибку логируем: без неё в проде не отличить «чанк не доехал»
    // (404 после деплоя) от «чанк битый» (SyntaxError внутри самого чанка).
    console.error('[loadXlsx] не удалось загрузить чанк xlsx', err)
    throw new Error('Не удалось загрузить модуль Excel — обновите страницу и попробуйте снова')
  }
}
